module.exports = __webpack_public_path__ + "img/icon_wenjianword.a61c5dda.svg";